import { createApp } from 'vue'
import App from './App.vue'
import routes from './route/routes.js'
import BootstrapVueNext from 'bootstrap-vue-next'
import VueParticles from 'vue-particles'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'isotope-layout/dist/isotope.pkgd.min.js'

import "@/assets/css/materialdesignicons.min.css"
import "@/assets/css/mobiriseicons.css"
import "@/assets/css/magnific-popup.css"
import "@/assets/css/animate.min.css"
import '@/assets/scss/style.scss'
import '@/assets/css/style.css'

createApp(App).use(BootstrapVueNext).use(VueParticles).use(routes).mount('#app')
